
<template>
    <div class="login login-v2" data-pageload-addclass="animated fadeIn">
      <!-- begin brand -->
      <div class="auth-login">
        <div class="brand">
          <span class="logo"><img src="/assets/img/logo/p2c_logo.jpg"></span>
        </div>
      </div>
      <div class="login-content">
        <h3 class="font-weight-normal mb-4">
          <span class="text-first-letter">{{ title }}</span>
        </h3>
        <form class="margin-bottom-0">
          <form-group-thux :validator="$v.form.new_password1" :label="'New password' | translate" class="mb-2 mt-2">
                <template slot-scope="{ attrs, listeners }">
                  <b-form-input
                    type="password"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.new_password1"
                  />
                </template>
              </form-group-thux>
              <form-group-thux :validator="$v.form.new_password2" :label="'Confirm new password' | translate" class="mb-0 mt-2">
                <template slot-scope="{ attrs, listeners }">
                  <b-form-input
                    type="password"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.new_password2"
                  />
                </template>
              </form-group-thux>
          <div class="login-buttons mt-5 d-flex justify-content-between align-items-center">
            <button
              class="btn btn-success btn-lg"
              :disabled="$v.form.$invalid"
              @click.prevent="onSubmit()">
              {{ 'Confirm password' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
</template>

<script>
import { minLength, required, sameAs } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { ROUTES as AUTH_ROUTES } from './router'
import { TYPES as AUTH_TYPES } from './store'

export default {
  name: 'activate-and-reset-password-confirm',
  data () {
    return {
      form: {},
      topModalSize: 'sm',
      uid: this.$route.params.uid,
      token: this.$route.params.token,
      title: this.$t('Select a password to activate your user')
    }
  },
  methods: {
    ...mapActions({
      ...AUTH_TYPES.AUTH
    }),
    onSubmit () {
      if (!this.$v.$invalid) {
        const data = {
          token: this.token,
          uid: this.uid
        }
        this.activateAndResetPasswordConfirm({ ...data, ...this.form }).then(
          response => {
            this.$store.dispatch('notifySuccess', { title: this.$t('Thank You for activating your user'), text: this.$t('From this time you can use your email and your password to access the site') })
            setTimeout(() => {
              this.goToLogin()
            }, 1000)
          },
          error => {
            this.$store.dispatch('notifyError', { error: error.response.data })
          }
        )
      }
    },
    goToLogin () {
      this.$router.replace({ name: AUTH_ROUTES.LOGIN })
    }
  },
  created () {
    this.form = {}
  },
  mounted () {
    this.checkActivationUrl({
      uid: this.uid,
      token: this.token
    })
      .catch((e) => {
        this.$store.dispatch('notifyError', { error: e.response.data })
        setTimeout(() => {
          this.goToLogin()
        }, 500)
      })
  },
  validations: {
    form: {
      new_password1: {
        required,
        minLength: minLength(8)
      },
      new_password2: {
        required,
        minLength: minLength(8),
        sameAsPassword: sameAs('new_password1')
      }
    }
  }
}
</script>
